import { autoinject, bindable } from 'aurelia-framework';
import { AccountingRule, IAccountingRule, IAccountingRuleFolder, MissingMunicipalityAllocationRule } from "./accounting-rule-models";
import { ResponseHandler } from '../../utils/response-handler';
import { noop } from "lodash";
import { AccountingRuleApi } from "./accounting-rule-api";

@autoinject
export class MunicipalityAllocationMissingList {
	@bindable scopeId: string;
	@bindable scopeIsClosed: boolean;
	@bindable ruleInserted: (rule: any) => void;
	@bindable missingMunicipalityAllocationRules: MissingMunicipalityAllocationRule[];
	@bindable folders: IAccountingRuleFolder[];

	inProgress = true;

	constructor(private api: AccountingRuleApi, private responseHandler: ResponseHandler) {
	}

	insertSucceeded(addedRule: IAccountingRule, source: MissingMunicipalityAllocationRule) : void {
		const index = this.missingMunicipalityAllocationRules.indexOf(source);
		this.missingMunicipalityAllocationRules.splice(index, 1);

		const newRule = AccountingRule.createNew(addedRule);
		(this.ruleInserted || noop)({ rule: newRule });
	}

	async refreshAccountinRules() {
		this.missingMunicipalityAllocationRules = await this.api.getMissingMunicipalityAllocationRules(this.scopeId);
	}

	attached() {
		if (!this.missingMunicipalityAllocationRules) {
			this.refreshAccountinRules();
		}
	}

	toggleRule(rule: AccountingRule) {
		rule.expanded = !rule.expanded;
		return true;
	}
}
